// extracted by mini-css-extract-plugin
var _1 = "Empty_absolute__8ebdf";
var _2 = "Empty_grow__866b0";
var _3 = "Empty_large__bac03";
var _4 = "Empty_medium__b5b29";
var _5 = "Empty_mini__439fb";
var _6 = "Empty_root__96ba7";
var _7 = "Empty_xmini__23d0d";
export { _1 as "absolute", _2 as "grow", _3 as "large", _4 as "medium", _5 as "mini", _6 as "root", _7 as "xmini" }
